<!-- 代表案例 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_case.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="代表案例" en="REPRESENTATIVE CASE"></sub-title>
        <div class="list" v-if="list.length != 0">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="getDetail(item)"
          >
            <img :src="URL + item.newsImageUrl" alt="" class="post" />
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="desc">
                <span>项目概况：</span>
                {{ item.description }}
              </div>
            </div>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.pageIndex"
            :page-size="queryParams.pageSize"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
        <el-empty description="暂无案例" v-else></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        newsCode: "bdd6ac36a5f742aa9823e6991da141b7",
      },
      list: [],
      total: 0,
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.getList();
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    async getList() {
      let res = await this.$api.getCaseList(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    getDetail(item) {
      window.scrollTo({ top: 200 });
      this.$router.push("/case/case/caseDetail/" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 120px;

    .list {
      margin-top: 70px;

      .item {
        border: 1px solid #bab9b9;
        cursor: pointer;

        &:hover {
          .info .title {
            text-decoration: underline;
          }
        }

        & + .item {
          margin-top: 50px;
        }

        .post {
          width: 100%;
          height: 400px;
          object-fit: cover;
        }
        .info {
          padding: 20px;

          .title {
            color: $theme;
            font-size: 24px;
            margin-left: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .desc {
            margin-top: 10px;
            font-size: 15px;
            color: #5e5d5d;
            line-height: 30px;
            text-indent: 2em;

            span {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .detail {
    margin: 70px auto 120px;

    .title {
      text-align: center;
      font-size: 30px;
      color: #5e5d5d;
    }
    .rich {
      margin-top: 40px;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .list {
        margin-top: 20px;

        .item {
          .post {
            height: 150px;
          }
          .info {
            padding: 10px;

            .title {
              font-size: 18px;
            }
            .desc {
              font-size: 14px;
              line-height: 2;
            }
          }
        }
      }
    }
  }
}
</style>
